import React, { useState, useEffect } from 'react';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { fetchFacilityTypeAvailability } from '../../data/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const barColors = (values) => values.map(v => v >= 90 ? '#27ae60' : v >= 75 ? '#f39c12' : '#e74c3c');

const Top10FacilitiesChart = () => {
  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    fetchFacilityTypeAvailability().then(r => {
      setLabels(r.data.map(f => `${f.name} (${f.total})`));
      setValues(r.data.map(f => parseFloat(f.avail)));
    }).catch(console.error);
  }, []);

  const data = {
    labels,
    datasets: [{
      label: 'Availability %', data: values,
      backgroundColor: barColors(values), borderRadius: 4, barThickness: 18,
    }]
  };

  const minVal = values.length ? Math.max(0, Math.floor(Math.min(...values) / 10) * 10 - 10) : 0;

  const options = {
    indexAxis: 'y', responsive: true, maintainAspectRatio: false,
    layout: { padding: { right: 35 } },
    plugins: {
      legend: { display: false },
      datalabels: { display: true, anchor: 'end', align: 'right', color: '#444', font: { weight: '700', size: 10 }, formatter: v => v + '%' }
    },
    scales: {
      x: { min: minVal, max: 100, ticks: { font: { size: 10 }, callback: v => v + '%' }, grid: { color: '#f8fafc' } },
      y: { grid: { display: false }, ticks: { font: { size: 10, weight: '500' } } }
    }
  };

  return (
    <div className="chart-box">
      <h3>Facility Type wise Stock Availability</h3>
      <div style={{ flex: 1, position: 'relative', minHeight: '380px' }}>
        {values.length > 0 ? <Bar data={data} options={options} /> : <p style={{color:'#999',textAlign:'center'}}>Loading...</p>}
      </div>
    </div>
  );
};

export default Top10FacilitiesChart;
